module.exports = __webpack_public_path__ + "img/programmer.b1dbe14d.png";